module.exports = __webpack_public_path__ + "vuHohf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/vuHohf.png
// module id = 742
// module chunks = 320